import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8755 5.375L14.7637 2.86842C15.0315 2.51317 15.0747 2.04417 14.8757 1.64575C14.6768 1.24733 14.2772 1 13.8316 1H3.33333C2.0465 1 1 2.0465 1 3.33333V14.4167C1 14.7392 1.26133 15 1.58333 15C1.90533 15 2.16667 14.7392 2.16667 14.4167V9.75H13.8322C14.2778 9.75 14.6774 9.50208 14.8763 9.10425C15.0752 8.70642 15.0321 8.23742 14.7643 7.88158L12.8755 5.375ZM2.16667 8.58333V3.33333C2.16667 2.68992 2.68992 2.16667 3.33333 2.16667H13.8322L11.6797 5.02383C11.5233 5.2315 11.5233 5.51792 11.6797 5.72558L13.8322 8.58275L2.16667 8.58333Z"
      fill="currentColor"
    />
    <path
      d="M2.16667 8.58333V3.33333C2.16667 2.68992 2.68992 2.16667 3.33333 2.16667H13.8322L11.6797 5.02383C11.5233 5.2315 11.5233 5.51792 11.6797 5.72558L13.8322 8.58275L2.16667 8.58333Z"
      fill="currentColor"
    />
  </svg>
);

const FlagFilledIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default FlagFilledIcon;
